import * as React from "react";
import {
  Text
} from "@fluentui/react-components";
import { FluentDialog } from "./FluentDialog";
import { useGlobalContext } from "../state/GlobalStateProvider";

export const ErrorDialog: React.FC<React.PropsWithChildren> = () => {
    const [ globalState, globalDispatch ] = useGlobalContext();

    const clearError = React.useCallback(() =>
    {
        globalDispatch({
            type: "setError",
            payload: undefined
        });
    }, [globalDispatch]);

    return (
        <FluentDialog
            open={!!globalState?.error}
            title='An error occured'
            submitLabel="Ok"
            onSubmit={clearError}
            hideCancel={true}
        >
            <p>
                <Text>{globalState?.error?.message}</Text>
            </p>
        </FluentDialog>
  );
};